module.exports = __webpack_public_path__ + "img/Kinsale_logo.f3e5a461.png";